import BaseAdsTitle from './BaseAdsTitle';

export default BaseAdsTitle;
